import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import taskStatisticsApi from '../../api/taskStatistics';

// 获取任务概览数据
export const fetchTaskOverview = createAsyncThunk(
  'taskStatistics/fetchTaskOverview',
  async () => {
    const response = await taskStatisticsApi.getTaskOverview();
    return response.data;
  }
);

// 获取任务概览数据（按时间范围）
export const fetchTaskOverviewByRange = createAsyncThunk(
  'taskStatistics/fetchTaskOverviewByRange',
  async (params) => {
    const response = await taskStatisticsApi.getTaskOverviewByRange(params);
    return response.data;
  }
);

// 获取任务趋势数据
export const fetchTaskTrend = createAsyncThunk(
  'taskStatistics/fetchTaskTrend',
  async (params) => {
    const response = await taskStatisticsApi.getTaskTrend(params);
    return response.data;
  }
);

// 获取任务分布数据
export const fetchTaskDistribution = createAsyncThunk(
  'taskStatistics/fetchTaskDistribution',
  async (params) => {
    const response = await taskStatisticsApi.getTaskDistribution(params);
    return response.data;
  }
);

const initialState = {
  taskOverview: {
    data: null,
    loading: false,
    error: null
  },
  taskTrend: {
    data: null,
    loading: false,
    error: null
  },
  taskDistribution: {
    data: null,
    loading: false,
    error: null
  }
};

const taskStatisticsSlice = createSlice({
  name: 'taskStatistics',
  initialState,
  reducers: {
    clearTaskStatistics: (state) => {
      state.taskOverview.data = null;
      state.taskTrend.data = null;
      state.taskDistribution.data = null;
    }
  },
  extraReducers: (builder) => {
    // 处理任务概览数据
    builder
      .addCase(fetchTaskOverview.pending, (state) => {
        state.taskOverview.loading = true;
        state.taskOverview.error = null;
      })
      .addCase(fetchTaskOverview.fulfilled, (state, action) => {
        state.taskOverview.loading = false;
        state.taskOverview.data = action.payload;
      })
      .addCase(fetchTaskOverview.rejected, (state, action) => {
        state.taskOverview.loading = false;
        state.taskOverview.error = action.error.message;
      });

    // 处理任务概览数据（按时间范围）
    builder
      .addCase(fetchTaskOverviewByRange.pending, (state) => {
        state.taskOverview.loading = true;
        state.taskOverview.error = null;
      })
      .addCase(fetchTaskOverviewByRange.fulfilled, (state, action) => {
        state.taskOverview.loading = false;
        state.taskOverview.data = action.payload;
      })
      .addCase(fetchTaskOverviewByRange.rejected, (state, action) => {
        state.taskOverview.loading = false;
        state.taskOverview.error = action.error.message;
      });

    // 处理任务趋势数据
    builder
      .addCase(fetchTaskTrend.pending, (state) => {
        state.taskTrend.loading = true;
        state.taskTrend.error = null;
      })
      .addCase(fetchTaskTrend.fulfilled, (state, action) => {
        state.taskTrend.loading = false;
        state.taskTrend.data = action.payload;
      })
      .addCase(fetchTaskTrend.rejected, (state, action) => {
        state.taskTrend.loading = false;
        state.taskTrend.error = action.error.message;
      });

    // 处理任务分布数据
    builder
      .addCase(fetchTaskDistribution.pending, (state) => {
        state.taskDistribution.loading = true;
        state.taskDistribution.error = null;
      })
      .addCase(fetchTaskDistribution.fulfilled, (state, action) => {
        state.taskDistribution.loading = false;
        state.taskDistribution.data = action.payload;
      })
      .addCase(fetchTaskDistribution.rejected, (state, action) => {
        state.taskDistribution.loading = false;
        state.taskDistribution.error = action.error.message;
      });
  }
});

export const { clearTaskStatistics } = taskStatisticsSlice.actions;

// 选择器
export const selectTaskOverview = (state) => state.taskStatistics.taskOverview;
export const selectTaskTrend = (state) => state.taskStatistics.taskTrend;
export const selectTaskDistribution = (state) => state.taskStatistics.taskDistribution;

export default taskStatisticsSlice.reducer; 